module.exports = __webpack_public_path__ + "static/img/produto_g.63cda7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/spremidos-uva/produto_g.png
// module id = ijp2
// module chunks = 0